import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import "./HospitalDetail.css";

const HospitalDetail = () => {
  const [hospital, setHospital] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { id } = useParams(); // Get the hospital ID from URL

  useEffect(() => {
    const fetchHospital = async () => {
      try {
        const response = await axios.get(
          `https://api.swasthmitra.com/api/hospital/gethospital/${id}`
        );
        setHospital(response.data.data); // Assuming data is in 'data' field
        setLoading(false);
      } catch (err) {
        setError("Failed to fetch hospital details. Please try again later.");
        setLoading(false);
      }
    };

    fetchHospital();
  }, [id]);

  if (loading)
    return <div className="loading">Loading hospital details...</div>;

  if (error) return <div className="error">{error}</div>;

  return (
    <div className="hospital-detail-container">
      <h3>{hospital.name}</h3>
      <div className="image-map">
        <img
          src={hospital.hospitalImage || "https://via.placeholder.com/300"}
          alt={hospital.name}
        />
      </div>
      <p>
        <strong>Specialization:</strong>{" "}
        {hospital.hospitalSpecialization.join(", ")}
      </p>
      <p>
        <strong>Address:</strong> {hospital.address}
      </p>
      <p>
        <strong>Phone:</strong> {hospital.phoneNumber}
      </p>
      <div>
        {hospital.mapIframe && (
          <div className="store-map">
            <div dangerouslySetInnerHTML={{ __html: hospital.mapIframe }} />
          </div>
        )}
      </div>
    </div>
  );
};

export default HospitalDetail;
